import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { StopAction } from '../../../../../models/interactions.model';

@Component({
  selector: 'app-stop-action',
  imports: [MatIcon, CdkDragHandle, NgTemplateOutlet],
  templateUrl: './stop-action.component.html',
  styleUrl: './stop-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StopActionComponent {
  public readonly data = input.required<StopAction>();
  public readonly actions = input<TemplateRef<unknown>>();
}
